import { View } from 'react-native';
import { Icon } from '@/components/Icon';
import { Bar } from 'react-native-progress';
import theme from '@/config/theme';
import { allowNativeDriver } from '@/utils/allowNativeDriver';
import { styles } from './StarProgress.styles';

type StarProgressProps = {
  progress: number;
  withStar: boolean;
};

export const StarProgress = ({ progress, withStar }: StarProgressProps) => {
  return (
    <View style={styles.container}>
      <Bar
        color={theme.colors.primary}
        unfilledColor="rgba(81,191,146,0.3)"
        borderRadius={8}
        borderWidth={0}
        //https://github.com/facebook/react-native/issues/47635
        progress={progress}
        style={styles.bar}
        width={null}
        height={24}
        useNativeDriver={allowNativeDriver()}
      />
      {withStar ? (
        <Icon name="star" size={40} color={theme.colors.gold} solid />
      ) : null}
    </View>
  );
};
